import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...girdiler: ClassValue[]): string {
  return twMerge(clsx(girdiler));
}

export function paraFormatla(kurus: number, paraBirimi = 'TRY'): string {
  return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: paraBirimi }).format(kurus / 100);
}

/**
 * Kurussuz para: "₺4.200".
 *
 * Fiyat takvimi gibi yan yana onlarca tutarin durdugu yerlerde ",00" yalnizca
 * gurultu yapar; oda fiyatlari zaten tam liradir. Kurus anlamli oldugunda
 * (folyo, kasa) `paraFormatla` kullanilir.
 */
export function paraKisa(kurus: number, paraBirimi = 'TRY'): string {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: paraBirimi,
    maximumFractionDigits: 0,
  }).format(kurus / 100);
}

export function tarihFormatla(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return new Intl.DateTimeFormat('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(d);
}

/**
 * API zaman damgasini epoch ms'ye cevirir.
 *
 * Drizzle'in `timestamp_ms` kolonlari JS Date'e cozulur ve JSON'a ISO METIN
 * olarak yazilir. Sayi gibi kullanilirsa aritmetik NaN uretir (fark hesabi,
 * siralama). Bu yardimci her iki bicimi de kabul eder.
 */
export function anMs(deger: string | number | null | undefined): number | null {
  if (deger === null || deger === undefined) return null;
  const ms = typeof deger === 'number' ? deger : Date.parse(deger);
  return Number.isFinite(ms) ? ms : null;
}
